export var ComparisonPages;
(function (ComparisonPages) {
    ComparisonPages["BEST_EXCHANGE_RATES_PAGE"] = "Best Exchange Rates Page";
    ComparisonPages["COMPARE_PAGE"] = "Compare Page";
    ComparisonPages["CURRENCIES_HOMEPAGE"] = "Currencies Homepage";
    ComparisonPages["DISCLAIMER_PAGE"] = "Disclaimer Page";
    ComparisonPages["PROVIDER_HOMEPAGE"] = "Provider Homepage";
    ComparisonPages["PROVIDER_PAGE"] = "Provider Page";
    ComparisonPages["PROVIDER_ROUTE_PAGE"] = "Provider Route Page";
    ComparisonPages["VERSUS_PAGE"] = "Provider Versus Page";
    ComparisonPages["TRAVEL_MONEY"] = "Travel Money";
})(ComparisonPages || (ComparisonPages = {}));
